<template>
  <div class="row reward-form">
    <div v-if="alert" class="error-message text-center callout alert">{{ alert }}</div>
    <div class="medium-6 columns small-centered">
      reward name
      <input type="text"
             v-model="itemName"
             name="item_name"
             placeholder="offer name"
             maxlength="255"
             :disabled="!isEdit"
      />
      reward description (optional)
      <input type="text"
             v-model="description"
             name="meta"
             placeholder="reward description (optional)"
             maxlength="255"
             :disabled="!isEdit"
      />
      reward value
      <input type="text"
             v-model="itemValue"
             name="meta"
             placeholder="reward value"
             maxlength="255"
             :disabled="!isEdit"
      />
      reward POS string (optional)
      <input type="text"
             v-model="meta"
             name="meta"
             placeholder="reward POS string (optional)"
             maxlength="255"
             :disabled="!isEdit"
      />
      <div class="meta_json_selection">
        <select
          v-model="rewardType"
          name="reward_type"
          class="max-redemptions"
          id="reward_type"
          :disabled="!isEdit">
          <option value=""></option>
          <option value="%">%</option>
          <option value="$">$</option>
        </select>
        <input type="number"
               step="any"
               placeholder=0.00
               min=0.00
               name="reward_value"
               v-model="rewardValue"
               id="reward_value"
               :disabled="!isEdit"
        />
      </div>
      <input type="checkbox"
             v-model="status"
             :disabled="!isEdit"/>
      active
      <div class="image-container"
           v-if="isEdit"
           v-for="attachmentToUpload in rewardAttachmentUploads">
        <upload-attachment :key="attachmentToUpload.type + rewardId"
                           :attachment="attachmentToUpload.type === 'coupon' ? couponImage : preloadImage"
                           deleteClasses="delete-image"
                           :deleteText="isEdit ? 'remove' : 'null'"
                           fileUploadClasses="image-upload"
                           :label="attachmentToUpload.type"
                           loadingClasses="offer-loading"
                           :ownerId="rewardId"
                           ownerType="Reward"
                           shouldReload
                           :showInputFile="attachmentToUpload.type === 'coupon' ? !couponImage : !preloadImage"
                           showPreview
                           :uploadConfig="attachmentToUpload"
                           :disabled="!isEdit"
                           @configureAttachment="configureAttachmentResponse"
                           @reloadAttachments="loadImages">
        </upload-attachment>
      </div>
      <div class="row">
        <div class="small-12 columns center-button">
          <input
            type="submit"
            name="save-reward"
            value="update"
            id="reward-update-button"
            :disabled="!isEdit"
            @click.prevent="submit"
            class="button">
        </div>
      </div>
      <div v-if="isEdit" @click="destroy" class="link-delete delete-reward-link text-center">delete reward</div>
    </div>
  </div>
</template>
<script>
import AxiosMixin from "../../mixins/AxiosMixin";
import axiosConfig from "../../config/axios";
import {rewardAPI} from "../../services/api/rewardAPI";
import UploadAttachment from "../../components/FormItems/UploadAttachment";
import {isObject} from "../../utilities";

export default {
  name: 'RewardEdit',

  components: {
    UploadAttachment
  },
  mixins: [AxiosMixin],
  data() {
    return {
      alert: null,
      rewardId: null,
      itemName: null,
      itemValue: 0,
      description: null,
      status: false,
      meta: null,
      rewardType: null,
      rewardValue: null,
      preloadImage: null,
      couponImage: null,
      selectedView: 'sms',
    }
  },
  created() {
    this.$store.dispatch('LOAD_CURRENT_USER')
    this.rewardId = this.$route.params.id
    if (this.rewardId ) {
      this.initReward()
      this.loadImages()
    }
  },
  computed: {
    isEdit: function () {
      return !!this.rewardId
    },
    rewardAttachmentUploads: function () {
      let attachmentsToUpload = []
      const preload = {
        differentLabel: 'add display image',
        displayType: `preload-image-${this.rewardId}`,
        type: 'preload',
      }
      attachmentsToUpload.push(preload)
      let coupon = {
        differentLabel: 'add coupon image',
        displayType: `coupon-image-${this.rewardId}`,
        type: 'coupon',
      }
      attachmentsToUpload.push(coupon)
      return attachmentsToUpload
    },
    scopeSelectedGroups(){
      let scopedSelectedGroups = this.groupsWithSelected
      return scopedSelectedGroups;
    },
  },
  methods: {
    initReward() {
      this.$store.dispatch('LOAD_CURRENT_MERCHANT')
      this.loadReward()
    },
    afterRewardLoad(data, alert) {
      const rewardData = data ? data.reward : null
      if(rewardData) {
        this.itemName = rewardData.item_name
        this.itemValue= rewardData.item_value
        this.description = rewardData.description
        this.status = rewardData.status
        this.meta = rewardData.meta
        this.rewardType = rewardData.reward_type
        this.rewardValue = rewardData.reward_value
      }
    },
    async loadReward() {
      try {
        let response = await rewardAPI.getReward(this.rewardId)
        if (response.status == "200") {
          this.afterRewardLoad(response.data)
        } else {
          this.setAlert(response.data.error)
        }
      } catch (error) {
        this.setAlert(error.response.data.error)
      }
    },
    setAlert(message = 'there was an error please refresh & try again') {
      this.alert = message;
    },
    configureAttachmentResponse(responseData) {
      if (responseData.label === 'preload') {
        this.preloadImage = responseData
      } else {
        this.couponImage = responseData
      }
    },
    loadImages() {
      const url = `/api/v3/rewards/${this.rewardId}/attachments`
      axiosConfig.get(url)
        .then((response) => {
          const images = response.data
          if (isObject(images)) {
            let coupon,
              preload
            this.imageError = null
            images.forEach( image => {
              if (image.label === 'coupon') { coupon = image }
              if (image.label === 'preload') { preload = image }
            })
            this.couponImage = coupon ? coupon : null
            this.preloadImage = preload ? preload : null
          } else {
            this.imageError = 'error loading reward images'
          }
        })
        .catch((error) => {
          this.imageError = `could not load reward images. ${error}`
        })
    },
    saveRewardErrorHandler(error) {
      this.setAlert(error.response.data.error)
    },
    saveRewardSuccessHandler(data) {
      const errors = Object.values(data.errors),
        hasErrors = errors.length > 0
      if (hasErrors) {
        this.setAlert(errors[0][0])
        return
      }
      window.location.href = '/rewards'
    },
    async submit() {
      try {
        const params = {
          reward: {
            item_name: this.itemName,
            item_value: this.itemValue,
            description: this.description,
            status: this.status,
            meta: this.meta,
            reward_type: this.rewardType,
            reward_value: this.rewardValue,
            expiry_date_in_days: this.expiryDateInDays,
            max_redemptions: this.maxRedemptions,
          }
        }
        let response = await rewardAPI.patchReward(this.rewardId, params)
        if (response.status == "200") {
          this.saveRewardSuccessHandler(response.data)
        } else {
          this.setAlert(response.data.error)
        }
      } catch (error) {
        this.setAlert(error.response.data.error)
      }
    },
    async destroy() {
      if (window.confirm('Are you sure you want to delete this reward?')) {
        try {
          let response = await rewardAPI.deleteReward(this.rewardId)
          if (response.status == "200") {
            this.saveRewardSuccessHandler(response.data)
          } else {
            this.setAlert(response.data.error)
          }
        } catch (error) {
          this.setAlert(error.response.data.error)
        }
      }
    },
    updateAlerts(itemKey, alert) {
      this.UPDATE_STATE_OBJECT({stateKey: 'alerts', itemKey, itemObject: alert})
    }
  }
}
</script>
<style>
.reward-form .image-container .attachment-label {
  color:  #128FF9;
}
.reward-form .image-container {
  margin: 14px 0 14px 0;
}
.reward-form .image-preview-description {
  display: none;
}
.reward-form .delete-attachment.link-delete.delete-image {
  margin-top: 0px;
}
.reward-form .image-preview.thumbnail {
  margin-bottom: 0px;
}
.reward-form .image-preview-item {
  text-align: center;
}
</style>
